









import Vue from 'vue';
import LandingHeader from '@/components/LandingHeader.vue';
import Hero from '@/components/Hero/Hero.vue';
import Timeline from '@/components/TimeLine/Timeline.vue';
import StartToStudySection from '@/components/StartToStudySection.vue';

export default Vue.extend({
  name: 'Home',
  components: {
    LandingHeader,
    Hero,
    Timeline,
    StartToStudySection,
  },
});
